import _ from 'lodash';

const useScatterPos = props => {
  const { coordValY, coordValX } = props;
  const spacer = 20; // pixels
  const minStemLength = 24; // pixels;

  const setPassivePos = (passiveData, minY, maxY, yScale, yPadding) => {
    let topLeft = yScale(minY) - yPadding;
    let topRight = topLeft;
    let bottomLeft = yScale(maxY) + yPadding;
    let bottomRight = bottomLeft;
    if (!passiveData || passiveData.length === 0) return;

    passiveData.reverse().forEach(d => {
      switch (d.quadrant) {
        default:
          break;
        case 'topLeft': {
          topLeft =
            topLeft + spacer >= yScale(0)
              ? yScale(minY) + spacer
              : topLeft + spacer;
          topLeft =
            yScale(coordValY(d)) + d.radius < topLeft
              ? yScale(minY) + spacer * 1.5
              : topLeft;
          d.lblY = !d.lockedInPlace ? topLeft : d.lblY;
          d.x = 0;
          break;
        }
        case 'topRight': {
          topRight =
            topRight + spacer >= yScale(0)
              ? yScale(minY) + spacer
              : topRight + spacer;
          topRight =
            yScale(coordValY(d)) + d.radius < topRight
              ? yScale(minY) + spacer * 1.5
              : topRight;
          d.lblY = !d.lockedInPlace ? topRight : d.lblY;
          break;
        }
        case 'bottomLeft': {
          bottomLeft =
            bottomLeft - spacer <= yScale(0)
              ? yScale(maxY) - spacer
              : bottomLeft - spacer;
          bottomLeft =
            yScale(coordValY(d)) - d.radius > bottomLeft
              ? yScale(maxY) - spacer * 1.5
              : bottomLeft;
          d.lblY = !d.lockedInPlace ? bottomLeft : d.lblY;
          break;
        }
        case 'bottomRight': {
          bottomRight =
            bottomRight - spacer <= yScale(0)
              ? yScale(maxY) - spacer
              : bottomRight - spacer;
          bottomRight =
            yScale(coordValY(d)) - d.radius > bottomRight
              ? yScale(maxY) - spacer * 1.5
              : bottomRight;
          d.lblY = !d.lockedInPlace ? bottomRight : d.lblY;
          break;
        }
      }
    });
  };

  // for each quadrant
  // find the corresponding node
  // place text spacer=20 pixels above
  // check for collison with three neighboring points
  const positionLabels = (
    filteredData,
    minY,
    maxY,
    yScale,
    xScale,
    getNodeText,
    longLabels,
    yPadding,
    xPadding,
    maxX
  ) => {
    const checkForCollisions = (node, spacer) => {
      let bboxWidth = 122; // bbox.width;
      let bboxHeight = 24; // bbox.height;
      const elem = document.getElementById(node.textId);
      if (elem) {
        elem.innerHTML = getNodeText(node, null, longLabels, xScale, xPadding, maxX);
        const bbox = elem.getBBox();
        bboxWidth = bbox.width;
        bboxHeight = bbox.height;
      }

      const topBoundary = yScale(minY) - yPadding;
      const bottomBoundary = yScale(maxY) + yPadding;

      // set the initial positions of the text
      node.nodeY = yScale(coordValY(node));
      if (node.isPassive === false) {
        node.lblY =
          node.quadrant === 'topLeft' || node.quadrant === 'topRight'
            ? node.nodeY - (Math.max(spacer, minStemLength) + node.radius)
            : node.nodeY + (Math.max(spacer, minStemLength) + node.radius);
      }
      // else {
      //   node.lblY = (node.quadrant === 'topLeft' || node.quadrant === 'topRight')
      //     ? topBoundary
      //     : bottomBoundary;
      // }

      const quadData = filteredData.filter(x => x.quadrant === node.quadrant);
      const nodeIndex = quadData.indexOf(node);
      const nodeXPos = xScale(coordValX(node));

      const checkYLabelOverCircle = (node, neighbor, buffer) => {
        buffer = 2;
        // label inside circle
        let debugg = node.lblY >= neighbor.nodeY - (neighbor.radius + buffer);
        debugg =
          debugg && node.lblY <= neighbor.nodeY + (neighbor.radius + buffer);

        // circle inside label
        debugg =
          debugg ||
          (neighbor.nodeY <= node.lblY - (bboxHeight + buffer) &&
            neighbor.nodeY >= node.lblY + (bboxHeight + buffer));
        return debugg;
      };

      const checkYLabelOverLabel = (node, neighbor, buffer) => {
        buffer = 2;
        let debugg =
          node.lblY >= neighbor.lblY - buffer &&
          node.lblY <= neighbor.lblY + bboxHeight + buffer;
        debugg =
          debugg ||
          (neighbor.lblY >= node.lblY - buffer &&
            neighbor.lblY <= node.lblY + bboxHeight + buffer);
        return debugg;
      };

      const adjustForBoundaryOvershoot = node => {
        let tIndex = nodeIndex;

        node.lblY =
          node.quadrant.startsWith('top') === true
            ? node.nodeY - (Math.max(spacer, minStemLength) + node.radius)
            : node.nodeY + (Math.max(spacer, minStemLength) + node.radius);

        while (tIndex > 0) {
          const nextTNode = quadData[tIndex - 1]; // get the next closest node
          const nextXPos = xScale(coordValX(nextTNode));
          let adjusted = false;

          switch (node.quadrant) {
            default:
              break;
            case 'topLeft': {
              if (nextXPos > nodeXPos - bboxWidth) {
                // do they cross  horizontally
                const labXCir = checkYLabelOverCircle(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXCir === true) {
                  node.lblY =
                    Math.min(nextTNode.nodeY, node.nodeY) -
                    (nextTNode.radius + spacer);
                  adjusted = true;
                }
                const labXLab = checkYLabelOverLabel(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXLab === true) {
                  node.lblY =
                    Math.min(nextTNode.lblY, node.nodeY) -
                    (bboxHeight + spacer);
                  adjusted = true;
                }
                tIndex = adjusted ? nodeIndex + 1 : tIndex;
              }
              break;
            }
            case 'bottomLeft': {
              if (nextXPos > nodeXPos - bboxWidth) {
                // do they cross  horizontally
                const labXCir = checkYLabelOverCircle(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXCir === true) {
                  node.lblY =
                    Math.max(nextTNode.nodeY, node.nodeY) +
                    (nextTNode.radius + spacer);
                  adjusted = true;
                }
                const labXLab = checkYLabelOverLabel(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXLab === true) {
                  node.lblY =
                    Math.max(nextTNode.lblY, node.nodeY) +
                    (bboxHeight + spacer);
                  adjusted = true;
                }
                tIndex = adjusted ? nodeIndex + 1 : tIndex;
              } else {
                tIndex = 0;
              }
              break;
            }
            case 'topRight': {
              if (nextXPos < nodeXPos + bboxWidth) {
                // do they cross  horizontally
                const labXCir = checkYLabelOverCircle(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXCir === true) {
                  node.lblY =
                    Math.min(nextTNode.nodeY, node.nodeY) -
                    (nextTNode.radius + spacer);
                  adjusted = true;
                }
                const labXLab = checkYLabelOverLabel(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXLab === true) {
                  node.lblY =
                    Math.min(nextTNode.lblY, node.nodeY) -
                    (bboxHeight + spacer);
                  adjusted = true;
                }
                tIndex = adjusted ? nodeIndex + 1 : tIndex;
              } else {
                tIndex = 0;
              }
              break;
            }
            case 'bottomRight': {
              if (nextXPos < nodeXPos + bboxWidth) {
                // do they cross  horizontally
                const labXCir = checkYLabelOverCircle(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXCir === true) {
                  node.lblY =
                    Math.max(nextTNode.nodeY, node.nodeY) +
                    (nextTNode.radius + spacer);
                  adjusted = true;
                }
                const labXLab = checkYLabelOverLabel(
                  node,
                  nextTNode,
                  spacer / 4
                );
                if (labXLab === true) {
                  node.lblY =
                    Math.max(nextTNode.lblY, node.nodeY) +
                    (bboxHeight + spacer);
                  adjusted = true;
                }
                tIndex = adjusted ? nodeIndex + 1 : tIndex;
              } else {
                tIndex = 0;
              }
              break;
            }
          }

          tIndex -= 1;
        }
      };

      // const checkBehind = node => {

      // };

      let index = nodeIndex;
      while (index > 0) {
        // loop to the end
        const nextNode = quadData[index - 1]; // get the next closest node
        const nextXPos = xScale(coordValX(nextNode));
        const nextLblY = nextNode.lblY;
        const nextNodeY = nextNode.nodeY;
        let inner;
        let outer;
        const halfBBoxHeight = bboxHeight / 2;
        const diameter = nextNode.radius * 2;

        switch (node.quadrant) {
          default:
            break;
          case 'topLeft': {
            // node.label = `tl_${nodeIndex}_${node.lblY.toFixed(1)}_${node.textId}`;
            outer = Math.min(nextLblY, nextNodeY - diameter); // closer to the top boundary
            inner = Math.max(nextLblY, nextNodeY + diameter); // closer to the X-Axis
            if (nextXPos > nodeXPos - bboxWidth) {
              // does it cross over
              if (node.lblY + halfBBoxHeight >= outer && node.lblY <= inner) {
                node.lblY = outer - (halfBBoxHeight + spacer);
                if (node.lblY < topBoundary) {
                  adjustForBoundaryOvershoot(node);
                  node.lblY =
                    node.lblY < topBoundary
                      ? node.nodeY -
                        (Math.max(spacer, minStemLength) + node.radius)
                      : node.lblY;
                  index = 0;
                } else index = nodeIndex + 1;
              }
            }
            break;
          }
          case 'bottomLeft': {
            // node.label = `bl_${nodeIndex}_${node.lblY.toFixed(1)}_${node.textId}`;
            inner = Math.min(nextLblY, nextNodeY - diameter); // closer to the X-Axis
            outer = Math.max(nextLblY, nextNodeY + diameter); // closer to the bottom boundary
            if (nextXPos > nodeXPos - bboxWidth) {
              // does it cross over
              if (node.lblY >= inner && node.lblY - halfBBoxHeight <= outer) {
                node.lblY = outer + (halfBBoxHeight + spacer);
                if (node.lblY > bottomBoundary) {
                  adjustForBoundaryOvershoot(node);
                  node.lblY =
                    node.lblY > bottomBoundary
                      ? node.nodeY +
                        (Math.max(spacer, minStemLength) + node.radius)
                      : node.lblY;
                  index = 0;
                } else index = nodeIndex + 1;
              }
            }
            // node.label = `${nodeIndex}_${node.lblY.toFixed(1)}_${node.textId}`;
            break;
          }
          case 'topRight': {
            // node.label = `tr_${nodeIndex}_${node.lblY.toFixed(1)}_${node.nodeY.toFixed(1)}`;
            outer = Math.min(nextLblY, nextNodeY - diameter); // closer to the top boundary
            inner = Math.max(nextLblY, nextNodeY + diameter); // closer to the X-Axis
            if (nextXPos < nodeXPos + bboxWidth) {
              // does it cross over
              if (node.lblY + halfBBoxHeight >= outer && node.lblY <= inner) {
                node.lblY = outer - (halfBBoxHeight + spacer);
                if (node.lblY < topBoundary) {
                  adjustForBoundaryOvershoot(node);
                  node.lblY =
                    node.lblY < topBoundary
                      ? node.nodeY -
                        (Math.max(spacer, minStemLength) + node.radius)
                      : node.lblY;
                  index = 0;
                } else index = nodeIndex + 1;
              }
            }
            break;
          }
          case 'bottomRight': {
            // node.label = `br_${nodeIndex}_${node.lblY.toFixed(1)}_${node.textId}`;
            inner = Math.min(nextLblY, nextNodeY - diameter); // closer to the X-Axis
            outer = Math.max(nextLblY, nextNodeY + diameter); // closer to the bottom boundary
            if (nextXPos < nodeXPos + bboxWidth) {
              // does it cross over
              if (node.lblY >= inner && node.lblY - halfBBoxHeight <= outer) {
                node.lblY = outer + (halfBBoxHeight + spacer);
                if (node.lblY > bottomBoundary) {
                  adjustForBoundaryOvershoot(node);
                  node.lblY =
                    node.lblY > bottomBoundary
                      ? node.nodeY +
                        (Math.max(spacer, minStemLength) + node.radius)
                      : node.lblY;
                  index = 0;
                } else index = nodeIndex + 1;
              }
            }
            break;
          }
        }

        index -= 1;
      }
    };

    // test
    // filteredData.forEach(d => { d.lblY = -1; });
    // filteredData = filteredData.filter(d => d.quadrant === 'bottomLeft');

    const getQuadrantSpacer = d => {
      const spacers = { tr: 0, tl: 0, br: 0, bl: 0 };
      spacers.tr = filteredData.filter(d => d.quadrant === 'topRight');
      spacers.tl = filteredData.filter(d => d.quadrant === 'topLeft');
      spacers.br = filteredData.filter(d => d.quadrant === 'bottomRight');
      spacers.bl = filteredData.filter(d => d.quadrant === 'bottomLeft');

      // get the node closest to the x-axis
      const getVal = o => {
        return yScale(coordValY(o));
      };

      let height;
      let spacer;
      let m;
      switch (d.quadrant) {
        case 'topLeft': {
          m = _.max(_.map(spacers.tl, getVal));
          height = m - yScale(minY);
          spacer = Math.max(
            Math.min(height / spacers.tl.length - d.radius * 1.5, 30),
            8
          );
          break;
        }
        case 'topRight': {
          m = _.max(_.map(spacers.tr, getVal));
          height = m - yScale(minY);
          spacer = Math.max(
            Math.min(height / spacers.tr.length - d.radius * 1.5, 30),
            8
          );
          break;
        }
        case 'bottomRight': {
          m = _.min(_.map(spacers.br, getVal));
          height = yScale(maxY) - m;
          spacer = Math.max(
            Math.min(height / spacers.br.length - d.radius * 1.5, 36),
            10
          );
          break;
        }
        case 'bottomLeft': {
          m = _.min(_.map(spacers.bl, getVal));
          height = yScale(maxY) - m;
          spacer = Math.max(
            Math.min(height / spacers.bl.length - d.radius * 1.5, 36),
            10
          );
          break;
        }
        default:
          spacer = 20;
      }
      spacer = Math.max(Math.min(spacer, 20), 5);
      return spacer;
    };

    filteredData.forEach(d => {
      d.lblY = yScale(d.lblY);
      const spacer = getQuadrantSpacer(d);
      checkForCollisions(d, spacer);
    });
    const passiveData = filteredData.filter(d => d.isPassive);
    if (passiveData && passiveData.length > 0) {
      setPassivePos(passiveData, minY, maxY, yScale, yPadding);
      // passiveData.forEach(d => checkForCollisions(d));
    }
    filteredData.forEach(d => {
      d.lblY = yScale.invert(d.lblY);
    });
  };
  return [positionLabels];
};

export default useScatterPos;
